<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="main-card-body">
        <div class="hai">
          <div class="body-header d-flex mb-0">
            <div>
              <h4 class="card-header-title">Phân quyền tính năng</h4>
            </div>
            <div class="text-right">
              <el-button
                round
                class="btn-default"
                @click="fn_openAddFeatureDialog()"
                >Thêm mã quyền</el-button
              >
              <el-button
                round
                class="btn-back"
                @click="fn_go()"
                >Quay lại</el-button
              >
              <el-button
                v-if="aRole('Customer')"
                round
                class="btn-default"
                @click="fn_setToDefault()"
                >Quyền mặc định</el-button
              >
            </div>
          </div>
        </div>
        <div class="main-body mt-1">
          <div id="table_role" @click="handleClick"></div>
        </div>
      </div>
    </div>
    <el-dialog
      title="Thêm mã quyền"
      :visible.sync="dialogAddFeatureVisible"
      width="520px"
      :close-on-click-modal="false"
      @close="fn_resetAddFeatureForm()"
    >
      <el-form
        ref="addFeatureForm"
        :model="featureForm"
        :rules="featureFormRules"
        label-position="top"
      >
        <el-form-item label="Mã quyền cha" prop="parent_id">
          <el-select
            v-model="featureForm.parent_id"
            filterable
            clearable
            placeholder="Chọn mã quyền cha"
            style="width: 100%"
          >
            <el-option
              v-for="item in featureParentOptions"
              :key="item.id"
              :label="`${item.code || ''} - ${item.name || ''}`"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Mã quyền" prop="code">
          <el-input
            v-model.trim="featureForm.code"
            placeholder="Nhập mã quyền"
            @change="featureForm.code = (featureForm.code || '').trim().toUpperCase()"
          ></el-input>
        </el-form-item>
        <el-form-item label="Tên quyền" prop="name">
          <el-input
            v-model="featureForm.name"
            placeholder="Nhập tên quyền"
          ></el-input>
        </el-form-item>
        <el-form-item label="Trạng thái">
          <el-checkbox v-model="featureForm.active">Kích hoạt mã quyền</el-checkbox>
        </el-form-item>
      </el-form>
      <div slot="footer" class="text-center">
        <el-button round @click="dialogAddFeatureVisible = false">Hủy</el-button>
        <el-button round class="btn-default" :loading="savingFeature" @click="fn_saveFeature">
          Lưu
        </el-button>
      </div>
    </el-dialog>
    <Loading v-if="loading"/>
  </div>
</template>
<script>
import LanguageService from "../../../service/LanguageService";
import MethodService from "../../../service/MethodService";
import RoleApi from "../../../moduleApi/RoleApi";
import FeatureApi from "../../../moduleApi/FeatureApi";
import RoleFearureApi from "../../../moduleApi/RoleFearureApi";
import Loading from "@/component/Loading";

export default {
  components: {
    Loading,
  },
  data() {
    return {
      loading: false,
      savingFeature: false,
      dialogAddFeatureVisible: false,
      featureParentOptions: [],
      featureForm: {
        parent_id: "",
        code: "",
        name: "",
        active: true,
      },
      featureFormRules: {
        parent_id: [
          { required: true, message: "Vui lòng chọn mã quyền cha", trigger: "change" }
        ],
        code: [
          { required: true, message: "Vui lòng nhập mã quyền", trigger: "blur" }
        ],
        name: [
          { required: true, message: "Vui lòng nhập tên quyền", trigger: "blur" }
        ],
      },
      aRole: MethodService.checkRole,
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        id: null,
        viewMode: "create",
        moduleName: "RoleFeature", //requied
        dataDefault: {
          listRole: [],
          listFeaturesByCompany: [],
          listRoleFeature: [],
          listFeatures: [],
          listFatherFeatures: [],
          listIdRole: [],
        },
        currentUser: MethodService.getCurrentUser(),
        currentCompany: MethodService.getCompanyInfo(),
        companyInfo: {},
      }
    };
  },
  methods: {
    fn_buildRoleFilters() {
      const filters = ["disabled!=true"];
      if (this.mData.currentCompany && this.mData.currentCompany.id) {
        filters.push(`company_id=${this.mData.currentCompany.id}`);
      }
      return filters.join("&");
    },
    fn_getCreatedFeatureFromResponse(res) {
      const result = res && res.result ? res.result : {};
      return result.feature || result.data || result;
    },
    fn_appendCreatedFeatureToParent(parentId, feature) {
      if (!parentId || !feature || !feature.id) {
        return;
      }
      const existedFeature = this.mData.dataDefault.listFeatures.some(item => {
        return item && String(item.id) === String(feature.id);
      });
      if (!existedFeature) {
        this.mData.dataDefault.listFeatures.push(feature);
      }
      const parentFeature = this.mData.dataDefault.listFeatures.find(item => {
        return item && String(item.id) === String(parentId);
      });
      if (parentFeature) {
        parentFeature.childs = [...new Set([...(parentFeature.childs || []), feature.id])];
      }
      this.fn_buildFatherFeatures();
    },
    fn_applyParentRelations() {
      const features = this.mData.dataDefault.listFeatures || [];
      const featureById = new Map();
      features.forEach(item => {
        if (item && item.id) {
          featureById.set(String(item.id), item);
        }
      });
      features.forEach(item => {
        const parentId = item && (
          item.parent_id ||
          item.parent_feature_id ||
          item.feature_parent_id ||
          item.father_id
        );
        if (!parentId || !item.id) {
          return;
        }
        const parent = featureById.get(String(parentId));
        if (parent) {
          parent.childs = [...new Set([...(parent.childs || []), item.id])];
        }
      });
    },
    fn_buildFatherFeatures() {
      this.fn_applyParentRelations();
      this.mData.dataDefault.listFatherFeatures = this.mData.dataDefault.listFeatures.filter(item => {
        return item.childs && item.childs.length > 0;
      });
      this.mData.dataDefault.listFatherFeatures.sort(function(a, b) {
        return (
          parseInt(a.code.substr(2, a.code.length)) -
          parseInt(b.code.substr(2, b.code.length))
          );
      });
      this.mData.dataDefault.listFatherFeatures.forEach(e => {
        var childFeature = this.mData.dataDefault.listFeatures.filter(x => {
          return e.childs.includes(x.id);
        });
        e.childs = childFeature;
      });
    },
    fn_resetAddFeatureForm() {
      this.featureForm = {
        parent_id: "",
        code: "",
        name: "",
        active: true,
      };
      if (this.$refs.addFeatureForm) {
        this.$refs.addFeatureForm.clearValidate();
      }
    },
    async fn_loadFeatureParentOptions() {
      const res = await FeatureApi.list({
        filters: "disabled!=true",
        limit: 10000,
      }, true);
      this.featureParentOptions = (res.result || [])
        .filter(item => item && item.childs && item.childs.length > 0)
        .sort((a, b) => {
          return String(a.code || "").localeCompare(String(b.code || ""), undefined, {
            numeric: true,
          });
        });
    },
    async fn_openAddFeatureDialog() {
      this.fn_resetAddFeatureForm();
      await this.fn_loadFeatureParentOptions();
      this.dialogAddFeatureVisible = true;
    },
    async fn_saveFeature() {
      this.$refs.addFeatureForm.validate(async valid => {
        if (!valid) {
          return false;
        }
        const featureCode = (this.featureForm.code || "").trim().toUpperCase();
        const featureName = (this.featureForm.name || "").trim();
        const parentFeature = this.featureParentOptions.find(item => item.id === this.featureForm.parent_id);
        if (!parentFeature) {
          window.toastr.error("Không tìm thấy mã quyền cha");
          return false;
        }
        const existedCode = this.featureParentOptions.some(item => {
          return String(item.code || "").toUpperCase() === featureCode;
        }) || this.mData.dataDefault.listFeatures.some(item => {
          return String(item.code || "").toUpperCase() === featureCode;
        });
        if (existedCode) {
          window.toastr.error("Mã quyền đã tồn tại");
          return false;
        }
        try {
          this.savingFeature = true;
          const createRes = await FeatureApi.CreateFeatureCode({
            parent_id: parentFeature.id,
            parent_feature_id: parentFeature.id,
            parent_code: parentFeature.code,
            code: featureCode,
            name: featureName,
            disabled: !this.featureForm.active,
          }, true);
          const createdFeature = this.fn_getCreatedFeatureFromResponse(createRes);
          this.fn_appendCreatedFeatureToParent(parentFeature.id, createdFeature);
          await this.fn_initData();
          setTimeout(async () => {
            await this.fn_checkedRoleVSFeature();
          }, 1000);
          window.toastr.success("Thêm mã quyền thành công");
          this.dialogAddFeatureVisible = false;
        } catch (error) {
          window.toastr.error("Thêm mã quyền không thành công");
        } finally {
          this.savingFeature = false;
        }
      });
    },

    async fn_setToDefault() {
      this.$confirm(LanguageService.lang.c_resetOriginalRole, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning",
        })
          .then(async () => {
            try {
              const res = await RoleFearureApi.ResetDefaultOption({ role_ids: this.mData.dataDefault.listIdRole })
              if (res && res.result.success) {
                window.toastr.success('Khôi phục quyền mặc định thành công.')
                await this.fn_initDataDefault();
              }
            } catch (error) {
              window.toastr.error('Khôi phục quyền mặc định thất bại.')
            }
          })
          .catch(() => {});
    },

    async fn_initDataDefault() {
      try {
        this.loading = true
        let promises = []
        if (this.aRole("AdminSystem")) {
          promises = [
            RoleApi.list({
              filters: this.fn_buildRoleFilters(),
              limit: 100
            }, true),
            FeatureApi.list({
              filters: "disabled!=true",
              limit: 10000,
            }, true),
            FeatureApi.GetAllFeaturesByCompany(),
            RoleFearureApi.list({
              filters: 'role_id:in:614f3be555078537477f46fc,614f3c0755078537477f46fd',
              limit: 10000
            }),
          ]
        } else {
          promises = [
            RoleApi.list({
              filters: this.fn_buildRoleFilters(),
              limit: 100
            }, true),
            FeatureApi.list({
              filters: "disabled!=true",
              limit: 10000,
            }, true),
            FeatureApi.GetAllFeaturesByCompany()
          ]
        }
        await Promise.all(promises).then(async res => {
          this.mData.dataDefault.listRole = res[0].result;
          this.mData.dataDefault.listFeatures = res[1].result;
          this.mData.dataDefault.listFeaturesByCompany = res[2].result;
          if (res.length == 4) this.mData.dataDefault.listRoleFeature = res[3].result;
          this.fn_buildFatherFeatures();

          this.mData.dataDefault.listIdRole = this.mData.dataDefault.listRole.map(role => role.id)
          await this.fn_initData();
          setTimeout(async () => {
            await this.fn_checkedRoleVSFeature();
          }, 1000);
        });
      } catch (error) {
        this.loading = false
       if (error && error.result && error.result.message) {
        window.toastr.error(error.result.message);
       } else {
        window.toastr.error("Lỗi tải dữ liệu");
       }
      }
    },


    async fn_toggleRoleCol(val, id) {
      if (!id) return;
      try {
        let res = null;
        if (val) {
          res = await RoleFearureApi.SaveCheckAllOption(id)
        } else {
          res = await RoleFearureApi.SaveUnCheckAllOption(id)
        }
        if (res && res.result.success) {
          await this.fn_initDataDefault();
        }
      } catch (error) {
        // console.log(error)
      }
    },

    async handleClick(e) {
      // console.log("e.target.id", e.target.id)
      // console.log("e.target.checked", e.target.checked)
      if (!e.target.attributes.data_count_child) {
        await this.fn_toggleRoleCol(e.target.checked, e.target.id);
      }

      if (e.target.matches(".form-check-input") && e.target.attributes.data_count_child) {
        const childLength = e.target.attributes.data_count_child.nodeValue;
        const checked = e.target.checked;
        const fatherId = e.target.classList[1];
        const childId = e.target.name;
        const roleId = e.target.value;
        let data = {
          role_id: "",
          feature_id: "",
          company_id: this.aRole("Customer") ? this.mData.currentCompany.id : '',
          disabled: false
        };
        const roleFearureChildApi = await RoleFearureApi.list(
          {
            filters: "role_id=" + roleId + "&feature_id=" + childId
          },
          true
        );
        if (
          roleFearureChildApi.result &&
          roleFearureChildApi.result.length == 0
        ) {
          data.role_id = roleId;
          data.feature_id = childId;
          await RoleFearureApi.create(data, true);
        } else {
          data.id = roleFearureChildApi.result[0].id;
          data.role_id = roleId;
          data.feature_id = childId;
          data.disabled = !checked;
          await RoleFearureApi.update(data, true);
        }

        const roleFearureApi = await RoleFearureApi.list(
          {
            filters: "role_id=" + roleId + "&feature_id=" + fatherId
          },
          true
        );
        if (roleFearureApi.result && roleFearureApi.result.length == 0) {
          data.role_id = roleId;
          data.feature_id = fatherId;
          await RoleFearureApi.create(data, true);
        } else {
          var allChecked = 0;
          let a = document.getElementsByClassName(fatherId + "_" + roleId);
          for (let i = 0; i < a.length; i++) {
            if (a[i].checked === false) {
              allChecked++;
            }
          }
          if (allChecked == childLength) {
            data.id = roleFearureApi.result[0].id;
            data.disabled = true;
            await RoleFearureApi.update(data, true);
          }
        }
      }
    },
    async fn_initData() {
      window.$("#table_role").html(
        `<div class="table-responsive-lg tableFixHead el-table__css">` +
          `<table class='table table-sm table-bordered table-hover'>` +
          `<thead>` +
          `<tr class="align-middle">` +
          `<th scope='col' style="width: 150px;" class="sticky-col first-col">Mã tính năng cha</th>` +
          `<th scope='col' style="width: 290px;" class="sticky-col second-col">Tên tính năng cha</th>` +
          `<th scope='col' style="width: 150px;" class="sticky-col third-col">Mã tính năng con</th>` +
          `<th scope='col' style="width: 490px;" class="sticky-col fouth-col">Tên tính năng con</th>` +
          this.fn_renderCol() +
          `</tr>` +
          `</thead>` +
          `<tbody>` +
          this.fn_renderRow() +
          `</tbody>` +
          `</table>` +
          `</div>`
      );
    },
    fn_renderCol() {
      let templateCol = "";
      if (this.aRole("Customer")) {
        for (let i = 0; i < this.mData.dataDefault.listRole.length; i++) {
          templateCol +=
            `<th scope='col' style="width: 60px;">` +
              `<div class="d-flex flex-column justify-content-between">` +
                `<p class="custom__header mb-1">${this.mData.dataDefault.listRole[i].name}</p>` +
                `<input
                    class="form-check-input"
                    type="checkbox"
                    id="${this.mData.dataDefault.listRole[i].id}"
                    value="${this.mData.dataDefault.listRole[i].id}"
                    name="${this.mData.dataDefault.listRole[i].id}"
                    ${this.mData.dataDefault.listRole[i].is_check_all ? 'checked' : ''}
                  >` +
                `</div>` +
            `</th>`;
        }
      } else if (this.aRole("AdminSystem")) {
        let roleAdmin = ["AdminSystem", "Customer"];
        for (let i = 0; i < roleAdmin.length; i++) {
          templateCol += `<th scope='col'>` + roleAdmin[i] + `</th>`;
        }
      }
      return templateCol;
    },
    fn_renderRow() {
      let templateRow = "";
      for (let i = 0; i < this.mData.dataDefault.listFatherFeatures.length; i++) {
        templateRow += this.fn_renderChild(this.mData.dataDefault.listFatherFeatures[i]);
      }
      return templateRow;
    },
    fn_renderChild(parent) {
      let templateRow = "";
      for (let i = 0; i < parent.childs.length; i++) {
        templateRow += "<tr>";
        templateRow += this.fn_renderColChild(parent, parent.childs[i].id, i);
        templateRow + "</tr>";
      }
      return templateRow;
    },
    fn_renderColChild(parent, child, index) {
      let templateCol = "";
      if (index == 0) {
        templateCol += `<td rowspan="${parent.childs.length}" class="child_code sticky-col-child first-col">${
          parent && parent.code ? parent.code : ""
        }</td>`;
        templateCol += `<td rowspan="${parent.childs.length}" class="text-left pl-2 sticky-col-child second-col">${parent.name}</td>`;
      }
      templateCol += `<td class="child_code sticky-col-child third-col">${
        this.fn_filterChilds(child) && this.fn_filterChilds(child).code
          ? this.fn_filterChilds(child).code
          : ""
      }</td>`;
      templateCol += `<td class="child_name text-left pl-2 sticky-col-child fouth-col">${
        this.fn_filterChilds(child) && this.fn_filterChilds(child).name
          ? this.fn_filterChilds(child).name
          : ""
      }</td>`;
      if (this.aRole("Customer")) {
        for (let i = 0; i < this.mData.dataDefault.listRole.length; i++) {
          templateCol +=
            `<td scope='col'>` +
              `<input
                class="form-check-input ${parent.id} ${parent.id}_${this.mData.dataDefault.listRole[i].id}"
                data_count_child="${parent.childs.length}"
                type="checkbox"
                value="${this.mData.dataDefault.listRole[i].id}"
                name="${child}"
              >` +
            `</td>`;
        }
      } else if (this.aRole("AdminSystem")) {
        let roleAdmin = ["AdminSystem", "Customer"];
        for (let i = 0; i < roleAdmin.length; i++) {
          templateCol +=
            `<td scope='col'>` +
              `<input
                class="form-check-input ${parent.id}"
                data_count_child="${parent.childs.length}"
                type="checkbox"
                value="${this.mData.dataDefault.listRole[i].id}"
                name="${child}">
              ` +
            `</td>`;
        }
      }
      return templateCol;
    },
    fn_checkShowInput(data) {
      let textNeedFind = '<td class="child_code"></td>';
      let a = data.slice(data.indexOf(textNeedFind), textNeedFind.length);
      if (a == textNeedFind) {
        return "hide_checkbox";
      } else {
        return "";
      }
    },
    fn_checkedRoleVSFeature() {
      let tableRole = document.getElementById("table_role");
      this.mData.dataDefault.listFeaturesByCompany.forEach(element => {
        if (element.disabled === true) {
          const inputCheck = tableRole.querySelector(
            `input[value="${element.role_id}"][name="${element.feature_id}"]`
          );
          if (inputCheck) {
            inputCheck.checked = false;
          }
        } else {
          const inputCheck = tableRole.querySelector(
            `input[value="${element.role_id}"][name="${element.feature_id}"]`
          );
          if (inputCheck) {
            inputCheck.checked = true;
          }
        }
      });
      this.mData.dataDefault.listRoleFeature.forEach(e => {
        const inputCheckSysAdmin = tableRole.querySelector(
          `input[value="614f3be555078537477f46fc"][name="${e.feature_id}"]`
        );
        if (inputCheckSysAdmin) {
          inputCheckSysAdmin.checked = true;
          // inputCheckSysAdmin.disabled = true;
          inputCheckSysAdmin.classList.add("disabled");
        }
        const inputCheckCustomer = tableRole.querySelector(
          `input[value="614f3c0755078537477f46fd"][name="${e.feature_id}"]`
        );
        if (inputCheckCustomer) {
          // inputCheckCustomer.disabled = true;
          inputCheckCustomer.classList.add("disabled");
        }
      });
      this.mData.dataDefault.listRole.forEach(e => {
        if (e.disabled === true) {
          const inputRoleDisabled = tableRole.querySelectorAll(
            `input[value="${e.id}"]`
          );
          if (inputRoleDisabled) {
            for (let i = 0; i < inputRoleDisabled.length; i++) {
              inputRoleDisabled[i].disabled = true;
              inputRoleDisabled[i].classList.add("disabled");
            }
          }
        }
      });
      this.loading = false
    },
    //Lọc lấy tên, code chức năng con
    fn_filterChilds(child) {
      let dataChild = this.mData.dataDefault.listFeatures.find(item => {
        return item.id == child;
      });
      return dataChild;
    },
    fn_go() {
      this.$router.go(-1);
    }
  },
  async created() {
    await this.fn_initDataDefault();
  }
};
</script>
<style scoped>
::v-deep table,
thead,
tr,
tbody,
th,
td {
  text-align: center;
}
::v-deep .table td {
  vertical-align: inherit;
}
::v-deep .tableFixHead {
  overflow-y: auto;
  overflow-x: hidden !important;
  height: calc(100vh - 160px);
  border-top: 1px solid #c8ced3;
}
::v-deep .el-table::before {
  width: 0;
}
::v-deep .tableFixHead thead th {
  position: sticky;
  top: -1px;
  z-index: 1;
  background-color: var(--orange);
  color: var(--white);
}
::v-deep .tableFixHead thead th::before {
  content: "";
  position: absolute;
  right: 0;
  bottom: -2px;
  left: 0;
  width: 100%;
  height: 1px;
  background-color: #c8ced3;
}
::v-deep .tableFixHead thead th::after {
  content: "";
  position: absolute;
  top: 0;
  right: -2px;
  width: 2px;
  height: 100%;
  background-color: #c8ced3;
}
::v-deep tbody {
  background: var(--white);
  height: calc(100vh - 220px);
  overflow: auto;
}
::v-deep thead,
tbody tr {
  width: 100%;
}
::v-deep thead {
  width: calc(100% - 10px);
  background: var(--orange);
}
::v-deep thead th {
  vertical-align: middle;
}
::v-deep table {
  width: 100%;
}
::v-deep .form-check-input {
  position: unset;
  margin-top: 0;
  margin-left: 0;
}
::v-deep .form-check-input:hover {
  cursor: pointer;
}
::v-deep .el-checkbox__input:after {
  box-sizing: content-box;
  content: "";
  border: 1px solid #fff;
  border-left: 0;
  border-top: 0;
  height: 7px;
  left: 4px;
  position: absolute;
  top: 1px;
  -webkit-transform: rotate(45deg) scaleY(0);
  transform: rotate(45deg) scaleY(0);
  width: 3px;
  -webkit-transition: -webkit-transform 0.15s ease-in 0.05s;
  transition: -webkit-transform 0.15s ease-in 0.05s;
  transition: transform 0.15s ease-in 0.05s;
  transition: transform 0.15s ease-in 0.05s,
    -webkit-transform 0.15s ease-in 0.05s;
  -webkit-transform-origin: center;
  transform-origin: center;
}
::v-deep .hide_checkbox {
  /* display: none; */
  visibility: hidden;
}
::v-deep .sticky-col {
  position: -webkit-sticky;
  position: sticky;
  z-index: 999 !important;
}
::v-deep .sticky-col-child {
  position: -webkit-sticky;
  position: sticky;
  background-color: rgb(253, 253, 253);
  z-index: 995 !important;
}
::v-deep .sticky-col-child::before {
  content: "";
  position: absolute;
  top: 0;
  left: -1px;
  width: 1px;
  height: 100%;
  background-color: #c8ced3;
}
::v-deep .sticky-col-child::after {
  content: "";
  position: absolute;
  top: 0;
  right: -1px;
  width: 1px;
  height: 100%;
  background-color: #c8ced3;
}
::v-deep .first-col {
  left: 0px;
}
::v-deep .second-col {
  left: 55px;
}
::v-deep .third-col {
  left: 137px;
}
::v-deep .fouth-col {
  left: 192px;
}
::v-deep .custom__header {
  color: var(--white);
  font-weight: 700;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
}
</style>
